export default "__VITE_ASSET__69083d5e__"